type CheckMark = {
  fill: string
  width: string
  height: string
  title: string
}

function CheckSingle(props: CheckMark) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'check single'

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <g fill={fill}>
        <path
          d='M44.207,11.293l-3-3c-.391-.391-1.023-.391-1.414,0L17.5,30.586l-9.293-9.293c-.391-.391-1.023-.391-1.414,0l-3,3c-.391,.391-.391,1.023,0,1.414l13,13c.195,.195,.451,.293,.707,.293s.512-.098,.707-.293L44.207,12.707c.391-.391,.391-1.023,0-1.414Z'
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default CheckSingle
